import { Map } from 'immutable';

const initialState = Map();

function createStarted(state, payload) {
  return state.mergeIn(['create', payload.uuid], {
    completed: false,
    failed: false,
    errors: {},
    loading: true,
  });
}

function createCompleted(state, payload) {
  return state.mergeIn(['create', payload.uuid], {
    completed: true,
    failed: false,
    errors: {},
    loading: false,
  });
}

function createFailed(state, payload) {
  return state.mergeIn(['create', payload.uuid], {
    completed: false,
    failed: true,
    errors: payload.errors,
    loading: false,
  });
}

export default function reducer(state = initialState, { type, payload }) {
  return state.withMutations((state) => {
    return (
      {
        ASSET_CREATE: createStarted,
        ASSET_CREATE_COMPLETED: createCompleted,
        ASSET_CREATE_FAILED: createFailed,
      }[type] || (() => state)
    )(state, payload);
  });
}
